import { useMutation } from "react-query";
import {
  fetchDocuSignData,
  fetchLoanSignData,
  fetchSubscriptionDocumentData,
  fetchSpvBoardResolutionSignData,
  fetchBoardResolutionSignData,
  fetchIssuerBoardResolutionSignData,
  fetchMasterSkuBorrowerSignData,
  fetchDeclarationOfAISignData,
  fetchIssuerAgreementSignData,
} from "../services/docusignService";

const useDocuSign = () => {
  return useMutation(["docu-sign"], fetchDocuSignData);
};

const useLoanSign = () => {
  return useMutation(["loan-sign"], fetchLoanSignData);
};

const useSubcriptionDocuSign = () => {
  return useMutation(["subscription-docu-sign"], fetchSubscriptionDocumentData);
};

const useSpvBoardResolutionSign = () => {
  return useMutation(
    ["spv-board-resolution-sign"],
    fetchSpvBoardResolutionSignData
  );
};

const useBoardResolutionSign = () => {
  return useMutation(["board-resolution-sign"], fetchBoardResolutionSignData);
};

const useIssuerBoardResolutionSign = () => {
  return useMutation(["issuer-board-resolution-sign"], fetchIssuerBoardResolutionSignData);
};

const useMasterSkuBorrowerSign = () => {
  return useMutation(
    ["master-sku-borrower-sign"],
    fetchMasterSkuBorrowerSignData
  );
};

const useDeclarationOfAISign = () => {
  return useMutation(["declaration-of-ai-sign"], fetchDeclarationOfAISignData);
};

const useIssuerAgreementSign = () => {
  return useMutation(["issuer-agreement-sign"], fetchIssuerAgreementSignData);
};

export {
  useDocuSign,
  useSubcriptionDocuSign,
  useLoanSign,
  useSpvBoardResolutionSign,
  useBoardResolutionSign,
  useIssuerBoardResolutionSign,
  useMasterSkuBorrowerSign,
  useDeclarationOfAISign,
  useIssuerAgreementSign,
};
